import type { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import type { IAppConfig } from '@core/common-legacy';
import { APP_CONFIG, AUTH_METHOD, AUTH_TOKEN, COMPANY_ID, ENVIRONMENT } from '@core/common-legacy';
import {
  HttpApiRequestOptions,
  HttpRequestData,
  IdentityHeader,
  IdentityHeaders,
} from '@core/http-types';

import type { AppEnvironment } from '../../environments/interface';

@Injectable()
export class RecruiteeRequestData extends HttpRequestData {
  public static getIdentityHeaders = (
    environment: AppEnvironment,
    isE2e: boolean,
  ): Partial<Record<IdentityHeader, string>> => {
    const realtimeEvent = Zone.current.get('realtime-event');
    const isStartup = !!Zone.current.get('startup');
    const realtimeHeaders = realtimeEvent ? { [IdentityHeader.RealtimeEvent]: realtimeEvent } : {};
    const startupHeaders = isStartup ? { [IdentityHeader.Startup]: 'true' } : {};
    return {
      [IdentityHeader.Client]: isE2e ? 'WebApp - e2e' : 'WebApp',
      [IdentityHeader.Env]: environment.environmentName,
      ...realtimeHeaders,
      ...startupHeaders,
    };
  };

  constructor(
    @Inject(AUTH_TOKEN) private authToken: string,
    @Inject(COMPANY_ID) protected currentCompanyId: number,
    @Inject(AUTH_METHOD) public authMethod: string,
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    @Inject(ENVIRONMENT) protected environment: AppEnvironment,
  ) {
    super();
  }

  public buildUrl(path: string = '', options: HttpApiRequestOptions = {}): string {
    let url = this.appConfig.apiUrl;

    if (this.authToken && this.currentCompanyId && !options.skipCompany) {
      url += `c/${this.currentCompanyId}/`;
    }

    let parsedPath = path;
    if (path[0] === '/') {
      parsedPath = path.substring(1);
    }

    return url + parsedPath;
  }

  public provideAuthHeaders(): { Authorization: string } | {} {
    return this.authMethod && this.authToken
      ? { Authorization: `${this.authMethod} ${this.authToken}` }
      : {};
  }

  public provideIdentityHeaders(): IdentityHeaders {
    return RecruiteeRequestData.getIdentityHeaders(this.environment, this.appConfig.isE2e);
  }

  public buildSignedUrl(path: string, searchHttpParams?: HttpParams): string {
    let url = `${this.appConfig.authUrl}f/c/${this.currentCompanyId}/`;

    let parsedPath = path;
    if (path[0] === '/') {
      parsedPath = path.substring(1);
    }

    url = url + parsedPath;

    return searchHttpParams ? `${url}?${searchHttpParams.toString()}` : url;
  }
}
